msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: kab\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-11-03 07:11\n"
"Last-Translator: \n"
"Language-Team: Kabyle\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: kab\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:135
msgid "Locked"
msgstr "Isekkeṛ"

#: src/components/account-block.jsx:141
msgid "Posts: {0}"
msgstr "Tisuffaɣ: {0}"

#: src/components/account-block.jsx:146
msgid "Last posted: {0}"
msgstr "Tasuffeɣt taneggarut: {0}"

#: src/components/account-block.jsx:161
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Awurman"

#: src/components/account-block.jsx:168
#: src/components/account-info.jsx:639
#: src/components/status.jsx:498
msgid "Group"
msgstr "Agraw"

#: src/components/account-block.jsx:178
msgid "Mutual"
msgstr "Temṭafaṛem"

#: src/components/account-block.jsx:182
#: src/components/account-info.jsx:1680
msgid "Requested"
msgstr "Yettwasra"

#: src/components/account-block.jsx:186
#: src/components/account-info.jsx:1671
msgid "Following"
msgstr "Yeṭṭafar"

#: src/components/account-block.jsx:190
#: src/components/account-info.jsx:1062
msgid "Follows you"
msgstr "Yeṭṭafaṛ-ik·ikem"

#: src/components/account-block.jsx:198
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# aneḍfar} other {# ineḍfaren}}"

#: src/components/account-block.jsx:207
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Yettwasenqed"

#: src/components/account-block.jsx:222
#: src/components/account-info.jsx:780
msgid "Joined <0>{0}</0>"
msgstr "Yerna-d ass <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "I lebda"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Yegguma ad d-yali umiḍan."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Ddu ɣer usebter n umiḍan"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Imeḍfaṛen"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:759
msgid "following.stats"
msgstr ""

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:776
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:312
#: src/pages/search.jsx:459
msgid "Posts"
msgstr "Tisuffaɣ"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1118
#: src/components/compose.jsx:2488
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1721
#: src/components/status.jsx:1738
#: src/components/status.jsx:1862
#: src/components/status.jsx:2474
#: src/components/status.jsx:2477
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1212
#: src/pages/trending.jsx:471
msgid "More"
msgstr "Ugar"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> ɣur-s tura amiḍan-a amaynut:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1276
msgid "Handle copied"
msgstr "Isem n useqdac yettwanɣel"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1279
msgid "Unable to copy handle"
msgstr "D awezɣi anɣal n yisem n useqdac"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1285
msgid "Copy handle"
msgstr "Nɣel isem n useqdac"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Ddu ɣer usebter n umaɣnu"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Wali tugna n umaɣnu"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Wali aqerru n umaɣnu"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "In Memoriam"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:750
msgid "This user has chosen to not make this information available."
msgstr "Aseqdac-a yefren ur tettili ara telɣut-a."

#: src/components/account-info.jsx:805
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} tisuffaɣ tiɣbula, {1} tiririyin, {2} izuzar"

#: src/components/account-info.jsx:821
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Tasuffeɣt taneggurt i wass-a} other {Tasuffeɣt taneggarut deg {2} wussan-a yezrin}}} other {{3, plural, one {{4} tsuffaɣ tineggura i wass-a} other {{5} tsuffaɣ tineggura deg {6} wussan-a yezrin}}}}"

#: src/components/account-info.jsx:834
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {1 tsuffeɣt taneggarut deg yiseggasen-a ineggura} other {{1} tsuffaɣ deg yiseggasen-a ineggura}}"

#: src/components/account-info.jsx:858
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Aɣbalu"

#: src/components/account-info.jsx:862
#: src/components/status.jsx:2252
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2056
#: src/pages/status.jsx:935
#: src/pages/status.jsx:1557
msgid "Replies"
msgstr "Tiririt"

#: src/components/account-info.jsx:866
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2068
#: src/pages/settings.jsx:1110
msgid "Boosts"
msgstr "Izuzar"

#: src/components/account-info.jsx:872
msgid "Post stats unavailable."
msgstr "Tidaddanin n yizen-a ulac-itent."

#: src/components/account-info.jsx:903
msgid "View post stats"
msgstr "Wali tidaddanin n tsuffeɣt"

#: src/components/account-info.jsx:1066
msgid "Last post: <0>{0}</0>"
msgstr "Tasuffeɣt taneggarut: <0>{0}</0>"

#: src/components/account-info.jsx:1080
msgid "Muted"
msgstr "Yettwasgugem"

#: src/components/account-info.jsx:1085
msgid "Blocked"
msgstr "Yettusewḥel"

#: src/components/account-info.jsx:1094
msgid "Private note"
msgstr "Tazmilt tusligt"

#: src/components/account-info.jsx:1151
msgid "Mention <0>@{username}</0>"
msgstr "Bder <0>@{username}</0>"

#: src/components/account-info.jsx:1163
msgid "Translate bio"
msgstr "Suqel tudert"

#: src/components/account-info.jsx:1174
msgid "Edit private note"
msgstr "Ẓreg tazmilt tusligt"

#: src/components/account-info.jsx:1174
msgid "Add private note"
msgstr "Rnu tazmilt tusligt"

#: src/components/account-info.jsx:1194
msgid "Notifications enabled for @{username}'s posts."
msgstr "Tettwarmed telɣut i tsuffaɣ n @{username}."

#: src/components/account-info.jsx:1195
msgid "Notifications disabled for @{username}'s posts."
msgstr "Tettwasens telɣut i tsuffaɣ n @{username}."

#: src/components/account-info.jsx:1207
msgid "Disable notifications"
msgstr "Sens ulɣuten"

#: src/components/account-info.jsx:1208
msgid "Enable notifications"
msgstr "Rmed ulɣuten"

#: src/components/account-info.jsx:1225
msgid "Boosts from @{username} enabled."
msgstr "Izuzar seg @{username} ttwaremden."

#: src/components/account-info.jsx:1226
msgid "Boosts from @{username} disabled."
msgstr "Izuzar seg @{username} ttwasensen."

#: src/components/account-info.jsx:1237
msgid "Disable boosts"
msgstr "Sens izuzar"

#: src/components/account-info.jsx:1237
msgid "Enable boosts"
msgstr "Sken izuzar"

#: src/components/account-info.jsx:1253
#: src/components/account-info.jsx:1263
#: src/components/account-info.jsx:1864
msgid "Add/Remove from Lists"
msgstr "Rnu/Kkes seg tebdarin"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1161
msgid "Link copied"
msgstr "Yettwanɣel wasaɣ"

#: src/components/account-info.jsx:1305
#: src/components/status.jsx:1164
msgid "Unable to copy link"
msgstr "D awezɣi ad d-yenɣel useɣwen"

#: src/components/account-info.jsx:1311
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1170
#: src/components/status.jsx:3251
msgid "Copy"
msgstr "Nɣel"

#: src/components/account-info.jsx:1326
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1186
msgid "Sharing doesn't seem to work."
msgstr "Beṭṭu yettban ur yeddi ara."

#: src/components/account-info.jsx:1332
#: src/components/status.jsx:1192
msgid "Share…"
msgstr "Bḍu…"

#: src/components/account-info.jsx:1352
msgid "Unmuted @{username}"
msgstr "Yettwakkes usgugem i @{username}"

#: src/components/account-info.jsx:1364
msgid "Unmute <0>@{username}</0>"
msgstr "Kkes asgugem <0>@{username}</0>"

#: src/components/account-info.jsx:1380
msgid "Mute <0>@{username}</0>…"
msgstr "Sgugem <0>@{username}</0>…"

#: src/components/account-info.jsx:1412
msgid "Muted @{username} for {0}"
msgstr "Sgugem @{username} i {0}"

#: src/components/account-info.jsx:1424
msgid "Unable to mute @{username}"
msgstr "D awezɣi asgugem n @{username}"

#: src/components/account-info.jsx:1445
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Kkes <0>@{username}</0> seg yineḍfaren?"

#: src/components/account-info.jsx:1465
msgid "@{username} removed from followers"
msgstr "@{username} yettwakkes seg yineḍfaren"

#: src/components/account-info.jsx:1477
msgid "Remove follower…"
msgstr "Kkes aneḍfar…"

#: src/components/account-info.jsx:1488
msgid "Block <0>@{username}</0>?"
msgstr "Sewḥel <0>@{username}</0>?"

#: src/components/account-info.jsx:1512
msgid "Unblocked @{username}"
msgstr "Yettwakkes usewḥel i @{username}"

#: src/components/account-info.jsx:1520
msgid "Blocked @{username}"
msgstr "Yettusewḥel @{username}"

#: src/components/account-info.jsx:1528
msgid "Unable to unblock @{username}"
msgstr "D awezɣi tukksa n usewḥel i @{username}"

#: src/components/account-info.jsx:1530
msgid "Unable to block @{username}"
msgstr "D awezɣi asewḥel i @{username}"

#: src/components/account-info.jsx:1540
msgid "Unblock <0>@{username}</0>"
msgstr "Kkes asewḥel <0>@{username}</0>"

#: src/components/account-info.jsx:1549
msgid "Block <0>@{username}</0>…"
msgstr "Sewḥel <0>@{username}</0>…"

#: src/components/account-info.jsx:1566
msgid "Report <0>@{username}</0>…"
msgstr "Cetki ɣef <0>@{username}</0>…"

#: src/components/account-info.jsx:1586
#: src/components/account-info.jsx:2097
msgid "Edit profile"
msgstr "Ẓreg amaɣnu"

#: src/components/account-info.jsx:1622
msgid "Withdraw follow request?"
msgstr "Kkes assuter n uḍfar?"

#: src/components/account-info.jsx:1623
msgid "Unfollow @{0}?"
msgstr "Ur ṭṭafar ara @{0}?"

#: src/components/account-info.jsx:1674
msgid "Unfollow…"
msgstr "Ur ṭṭafar ara…"

#: src/components/account-info.jsx:1683
msgid "Withdraw…"
msgstr "Kkes…"

#: src/components/account-info.jsx:1690
#: src/components/account-info.jsx:1694
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Ḍfeṛ"

#: src/components/account-info.jsx:1805
#: src/components/account-info.jsx:1859
#: src/components/account-info.jsx:1992
#: src/components/account-info.jsx:2092
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:818
#: src/components/compose.jsx:2444
#: src/components/compose.jsx:2917
#: src/components/compose.jsx:3125
#: src/components/compose.jsx:3355
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2976
#: src/components/status.jsx:3215
#: src/components/status.jsx:3713
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:868
#: src/pages/notifications.jsx:1082
#: src/pages/settings.jsx:76
#: src/pages/status.jsx:1299
msgid "Close"
msgstr "Mdel"

#: src/components/account-info.jsx:1810
msgid "Translated Bio"
msgstr "Tettwasuqqel tudert"

#: src/components/account-info.jsx:1904
msgid "Unable to remove from list."
msgstr "D awezɣi ad yettwakkes seg tebdart."

#: src/components/account-info.jsx:1905
msgid "Unable to add to list."
msgstr "D awezɣi ad yettwarnu ɣer tebdart."

#: src/components/account-info.jsx:1924
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "D awezɣi ad d-alint tebdarin."

#: src/components/account-info.jsx:1928
msgid "No lists."
msgstr "Ulac tibdarin."

#: src/components/account-info.jsx:1939
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Tabdart tamaynutt"

#: src/components/account-info.jsx:1997
msgid "Private note about <0>@{0}</0>"
msgstr "Tazmilt tusligt ɣef <0>@{0}</0>"

#: src/components/account-info.jsx:2027
msgid "Unable to update private note."
msgstr "D awezɣi aleqqem n tezmilt tusligt."

#: src/components/account-info.jsx:2050
#: src/components/account-info.jsx:2220
msgid "Cancel"
msgstr "Sefsex"

#: src/components/account-info.jsx:2055
msgid "Save & close"
msgstr "Sekles sakkin mdel"

#: src/components/account-info.jsx:2148
msgid "Unable to update profile."
msgstr "D awezɣi aleqqem n umaɣnu."

#: src/components/account-info.jsx:2155
#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Isem"

#: src/components/account-info.jsx:2168
msgid "Bio"
msgstr "Tameddurt"

#: src/components/account-info.jsx:2181
msgid "Extra fields"
msgstr "Urtiyen niḍen"

#: src/components/account-info.jsx:2187
msgid "Label"
msgstr "Tabzimt"

#: src/components/account-info.jsx:2190
msgid "Content"
msgstr "Agbur"

#: src/components/account-info.jsx:2223
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:934
msgid "Save"
msgstr "Sekles"

#: src/components/account-info.jsx:2276
msgid "username"
msgstr "isem n useqdac"

#: src/components/account-info.jsx:2280
msgid "server domain name"
msgstr "isem n taɣult n uqeddac"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Askar uffir yensa"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Askar uffir yermed"

#: src/components/columns.jsx:26
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:437
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:520
msgid "Home"
msgstr "Agejdan"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Suddes"

#: src/components/compose.jsx:394
msgid "You have unsaved changes. Discard this post?"
msgstr "Ɣur-k isenfal ur yettwaskelsen ara. Sefsex tasuffeɣt-a?"

#: src/components/compose.jsx:622
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr ""

#: src/components/compose.jsx:632
#: src/components/compose.jsx:650
#: src/components/compose.jsx:1361
#: src/components/compose.jsx:1623
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Tzemreḍ ad tsedduḍ 1 ufaylu kan.} other {Tzemreḍ ad tsedduḍ # yifuyla.}}"

#: src/components/compose.jsx:799
msgid "Pop out"
msgstr "Ldi deg ufaylu udhim"

#: src/components/compose.jsx:806
msgid "Minimize"
msgstr "Semẓẓi"

#: src/components/compose.jsx:842
msgid "Looks like you closed the parent window."
msgstr "Waqil tmedleḍ asfaylu amaraw."

#: src/components/compose.jsx:849
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Yettban-d ɣur-k yakan urti ideg turiḍ yeldi deg usfaylu amaraw, ha-t-an ad t-id-tessuffɣeḍ. Ttxil-k, ṛǧu ad yemmed syen εreḍ ticki."

#: src/components/compose.jsx:854
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Yettban tesεiḍ yakan urti ideg turiḍ yeldi deg usfaylu amaraw. Tiririt n usfaylu-a ad issefsex tira n tsuffeɣt deg usfaylu-a war asekles. Kemmel?"

#: src/components/compose.jsx:896
msgid "Pop in"
msgstr "Err-d seg usfaylu agejdan"

#: src/components/compose.jsx:906
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Tiririt ɣef tsuffeɣt n @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:916
msgid "Replying to @{0}’s post"
msgstr "Tiririt ɣef tsuffeɣt n @{0}"

#: src/components/compose.jsx:929
msgid "Editing source post"
msgstr "Aẓrag n tsuffeɣt n uɣbalu"

#: src/components/compose.jsx:976
msgid "Poll must have at least 2 options"
msgstr "Asisten ilaq ad yesεu ma drus snat textiṛiyin"

#: src/components/compose.jsx:980
msgid "Some poll choices are empty"
msgstr "Kra n yifranen n usisten d ilmawen"

#: src/components/compose.jsx:993
msgid "Some media have no descriptions. Continue?"
msgstr "Kra yimidyaten ulac ɣer-sen aglam. Kemmel?"

#: src/components/compose.jsx:1045
msgid "Attachment #{i} failed"
msgstr "Amedday #{i} yecceḍ"

#: src/components/compose.jsx:1139
#: src/components/status.jsx:2047
#: src/components/timeline.jsx:984
msgid "Content warning"
msgstr "Yir agbur"

#: src/components/compose.jsx:1155
msgid "Content warning or sensitive media"
msgstr "Yir agbur neɣ amidya amḥulfu"

#: src/components/compose.jsx:1191
#: src/components/status.jsx:93
#: src/pages/settings.jsx:304
msgid "Public"
msgstr "Azayaz"

#: src/components/compose.jsx:1196
#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Adigan"

#: src/components/compose.jsx:1200
#: src/components/status.jsx:95
#: src/pages/settings.jsx:307
msgid "Unlisted"
msgstr "War abdar"

#: src/components/compose.jsx:1203
#: src/components/status.jsx:96
#: src/pages/settings.jsx:310
msgid "Followers only"
msgstr "Imeḍfaṛen kan"

#: src/components/compose.jsx:1206
#: src/components/status.jsx:97
#: src/components/status.jsx:1925
msgid "Private mention"
msgstr "Abdar uslig"

#: src/components/compose.jsx:1215
msgid "Post your reply"
msgstr "Suffeɣ tiririt-ik·im"

#: src/components/compose.jsx:1217
msgid "Edit your post"
msgstr "Ẓreg tasuffeɣt-ik·im"

#: src/components/compose.jsx:1218
msgid "What are you doing?"
msgstr "Acu i txeddmeḍ?"

#: src/components/compose.jsx:1296
msgid "Mark media as sensitive"
msgstr "Creḍ allal n teywalt d anafri"

#: src/components/compose.jsx:1397
msgid "Add poll"
msgstr "Rnu asisten"

#: src/components/compose.jsx:1419
msgid "Add custom emoji"
msgstr "Timerna n imuji udmawan"

#: src/components/compose.jsx:1504
#: src/components/keyboard-shortcuts-help.jsx:151
#: src/components/status.jsx:913
#: src/components/status.jsx:1701
#: src/components/status.jsx:1702
#: src/components/status.jsx:2370
msgid "Reply"
msgstr "Err"

#: src/components/compose.jsx:1506
msgid "Update"
msgstr "Leqqem"

#: src/components/compose.jsx:1507
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Suffeɣ"

#: src/components/compose.jsx:1635
msgid "Downloading GIF…"
msgstr "Asader n GIF…"

#: src/components/compose.jsx:1663
msgid "Failed to download GIF"
msgstr "Yecceḍ usader n GIF"

#: src/components/compose.jsx:1775
#: src/components/compose.jsx:1852
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Ugar…"

#: src/components/compose.jsx:2257
msgid "Uploaded"
msgstr "Yuli-d"

#: src/components/compose.jsx:2270
msgid "Image description"
msgstr "Aglam n tugna"

#: src/components/compose.jsx:2271
msgid "Video description"
msgstr "Aglam n tvidyutt"

#: src/components/compose.jsx:2272
msgid "Audio description"
msgstr "Aglam n useklas ameslaw"

#: src/components/compose.jsx:2308
#: src/components/compose.jsx:2328
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Teɣzi n ufaylu meqqret aṭas. asali-ines yezmer ad yesεu uguren. Ԑreḍ ad tesneqseḍ deg teɣzi seg {0} ɣer {1} neɣ ugar."

#: src/components/compose.jsx:2320
#: src/components/compose.jsx:2340
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Amidya-a meqqer aṭas. asali-ines yezmer ad yesεu uguren. Ԑreḍ ad tesneqseḍ deg teɣzi seg {0}×{1}px ɣer {2}×{3}px."

#: src/components/compose.jsx:2348
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Afmiḍi meqqer aṭas. Asali-s yezmer ad d-yeglu s wuguren."

#: src/components/compose.jsx:2408
#: src/components/compose.jsx:2658
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Kkes"

#: src/components/compose.jsx:2425
#: src/compose.jsx:83
msgid "Error"
msgstr "Tuccḍa"

#: src/components/compose.jsx:2450
msgid "Edit image description"
msgstr "Ẓreg aglam n tugna"

#: src/components/compose.jsx:2451
msgid "Edit video description"
msgstr "Ẓreg aglam n tvidyut"

#: src/components/compose.jsx:2452
msgid "Edit audio description"
msgstr "Ẓreg aglam n useklas ameslaw"

#: src/components/compose.jsx:2497
#: src/components/compose.jsx:2546
msgid "Generating description. Please wait…"
msgstr "Asirew n uglam. Ttxil-k ṛǧu…"

#: src/components/compose.jsx:2517
msgid "Failed to generate description: {0}"
msgstr "Yecceḍ usirew n uglam: {0}"

#: src/components/compose.jsx:2518
msgid "Failed to generate description"
msgstr "Yecceḍ usirew n uglam"

#: src/components/compose.jsx:2530
#: src/components/compose.jsx:2536
#: src/components/compose.jsx:2582
msgid "Generate description…"
msgstr "Sirew aglam…"

#: src/components/compose.jsx:2569
msgid "Failed to generate description{0}"
msgstr "Yecceḍ usirew n uglam{0}"

#: src/components/compose.jsx:2584
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— armitan</0>"

#: src/components/compose.jsx:2603
msgid "Done"
msgstr "Yemmed"

#: src/components/compose.jsx:2639
msgid "Choice {0}"
msgstr "Tiferni {0}"

#: src/components/compose.jsx:2686
msgid "Multiple choices"
msgstr "Aṭas n tferniwin"

#: src/components/compose.jsx:2689
msgid "Duration"
msgstr "Tanzagt"

#: src/components/compose.jsx:2720
msgid "Remove poll"
msgstr "Kkes afmiḍi"

#: src/components/compose.jsx:2934
msgid "Search accounts"
msgstr "Nadi imiḍanen"

#: src/components/compose.jsx:2975
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Rnu"

#: src/components/compose.jsx:2988
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Tuccḍa deg usali n imiḍanen"

#: src/components/compose.jsx:3131
msgid "Custom emojis"
msgstr "Imujiten udmawanen"

#: src/components/compose.jsx:3151
msgid "Search emoji"
msgstr "Nadi imujit"

#: src/components/compose.jsx:3182
msgid "Error loading custom emojis"
msgstr "Tuccḍa deg usali n yimujiten udmawanen"

#: src/components/compose.jsx:3193
msgid "Recently used"
msgstr "Yettwaseqdac melmi kan"

#: src/components/compose.jsx:3194
msgid "Others"
msgstr "Wiyyaḍ"

#: src/components/compose.jsx:3232
msgid "{0} more…"
msgstr "{0} d wugar…"

#: src/components/compose.jsx:3370
msgid "Search GIFs"
msgstr "Nadi GIFs"

#: src/components/compose.jsx:3385
msgid "Powered by GIPHY"
msgstr "S lmendad n GIPHP"

#: src/components/compose.jsx:3393
msgid "Type to search GIFs"
msgstr "Aru i unadi n GIFs"

#: src/components/compose.jsx:3491
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:889
msgid "Previous"
msgstr "Uzwir"

#: src/components/compose.jsx:3509
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:906
msgid "Next"
msgstr "Uḍfir"

#: src/components/compose.jsx:3526
msgid "Error loading GIFs"
msgstr "Tuccḍa deg usali GIFs"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:691
msgid "Unsent drafts"
msgstr "Ur ttazen ara irewwayen"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Yettban ɣur-k irewwayen ur yettwaznen ara. Kemmel ansi i ten-teǧǧiḍ."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Kkes arewway-a?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Tuccḍa deg tukksa n urewway! Ttxil εreḍ tikkelt niḍen."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1336
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Kkes…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Tuccḍa deg tririt n waddad n tririt!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Kkes akk irewwayen?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Tuccḍa deg tukksa n yirewwayen! Ttxil εreḍ tikkelt niḍen."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Kkes-iten akk…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Ulac irewwayen i yettwafen."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1928
msgid "Poll"
msgstr "Asisten"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Amidya"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Ldi deg usfaylu amaynut"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:918
msgid "Accept"
msgstr "Qbel"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Agi"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1201
msgid "Accepted"
msgstr "Yettwaqbal"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Yettwagi"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Ulac ara yettwaskanen"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:438
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:302
#: src/pages/search.jsx:335
msgid "Accounts"
msgstr "Imiḍanen"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:519
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:848
#: src/pages/search.jsx:529
#: src/pages/status.jsx:1332
msgid "Show more…"
msgstr "Sken-d ugar…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:524
#: src/pages/search.jsx:534
msgid "The end."
msgstr "Taggara."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Inegzumen n unasiw"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Tallelt n yinegzumen n unasiw"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Tasuffeɣt tuḍfirt"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Tasuffeɣt iɛeddan"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Zgel akarusel ɣer tsuffeɣt tuḍfirt"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Zgel akarusel ɣer tsuffeɣt tudfirt"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Sali-d tisuffaɣ timaynutin"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Ldi talqayt n tsuffeɣt"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Sekcem</0> neɣ <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Alɣu ɣef usumɣer n ugbur neɣ <0/>abeddel n usqerdec semɣer/semẓẓi"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Mdel tasuffeɣt neɣ idiwenniyen"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> neɣ <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Tigejdit Focus deg uskar n waṭas n tgejda"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> ɣer <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Focus next column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Focus previous column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:125
msgid "Compose new post"
msgstr "Aru Tasuffeɣt tamaynut"

#: src/components/keyboard-shortcuts-help.jsx:129
msgid "Compose new post (new window)"
msgstr "Aru tasuffeɣt tamaynut (asfaylu amaynut)"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:138
msgid "Send post"
msgstr "Azen tasuffeɣt"

#: src/components/keyboard-shortcuts-help.jsx:140
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> neɣ <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:147
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:45
#: src/pages/search.jsx:284
msgid "Search"
msgstr "Nadi"

#: src/components/keyboard-shortcuts-help.jsx:155
msgid "Reply (new window)"
msgstr "Err (asfaylu amaynut)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
msgid "Like (favourite)"
msgstr "Ḥemmel (asmenyaf)"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> or <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:921
#: src/components/status.jsx:2396
#: src/components/status.jsx:2428
#: src/components/status.jsx:2429
msgid "Boost"
msgstr "Zuzer"

#: src/components/keyboard-shortcuts-help.jsx:174
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:180
#: src/components/status.jsx:1006
#: src/components/status.jsx:2453
#: src/components/status.jsx:2454
msgid "Bookmark"
msgstr "Ticreḍt n usebtar"

#: src/components/keyboard-shortcuts-help.jsx:184
msgid "Toggle Cloak mode"
msgstr "Rmed/Sens askar uffir"

#: src/components/keyboard-shortcuts-help.jsx:186
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Ẓreg tabdart"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "D awezɣi ad tettwaẓrag tebdart."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "D awezɣi timerna n tebdart."

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Sken tiririyin i yiεeggalen n tebdart"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Sken tiririyin i yimdanen i ṭṭafareɣ"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Ur skan ara tiririyin"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Ffer tisuffaɣ deg tebdart-a seg ugejdan/Aḍfar"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Snulfu-d"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Kkes tabdart-a?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "D awezɣi tukksa n tebdart."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Aglam n umidya"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:1050
#: src/components/status.jsx:1077
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Suqel"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:1064
#: src/components/status.jsx:1091
msgid "Speak"
msgstr "Mmeslay"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Ldi amidya aɣbalu deg usfaylu amaynut"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Ldi amidya aɣbalu"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Aneεruḍ n uglam n tugna. Ttxil-k rǧu…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Yecceḍ uglam n tugna"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Glem tugna…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Wali tasuffeɣt"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Amidya amḥulfu"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Yettwasizdeg: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3543
#: src/components/status.jsx:3639
#: src/components/status.jsx:3717
#: src/components/timeline.jsx:973
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1876
msgid "Filtered"
msgstr "Tettwasizdeg"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Yeffeɣ-d yizen-nni. Mmuqqel-it."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Tiririt ɣef tsuffeɣt. Senqed-itt."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Yettwalqam yizen-nni. Mmuqel-it."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Umuɣ"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Ales asali n usebter tura i uleqqem?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Yella lqem amaynut…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:22
#: src/pages/following.jsx:141
msgid "following.title"
msgstr ""

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Alukem"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:224
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1102
#: src/pages/trending.jsx:381
msgid "Mentions"
msgstr "Ibdaren"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:84
#: src/pages/home.jsx:184
#: src/pages/notifications.jsx:112
#: src/pages/notifications.jsx:524
msgid "Notifications"
msgstr "Alɣu"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Amaynut"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Amaɣnu"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Tibdarin"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:215
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Akk tibdarin"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Ticraḍ n yisebtar"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2062
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1106
msgid "Likes"
msgstr "Iεǧeb-as"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Ihacṭagen yettwaḍfaren"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Imzizdigen"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Iseqdacen yettwasgugmen"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Iseqdacen yettwasgugmen…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Imiḍanen yettusḥebsen"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Imiḍanen yettusḥebsen…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Imiḍanen…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:189
#: src/pages/status.jsx:835
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Qqen"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:441
msgid "Trending"
msgstr "Mucaεen"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Asedduklan"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Inegzumen / Ijga…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Iɣewwaṛen…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Ulɣu"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Talɣut-a seg umiḍan-ik niḍen."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Wali akk ulɣuten"

#: src/components/notification.jsx:70
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} yerra-d ɣef tsuffeɣt-ik s {emojiObject}"

#: src/components/notification.jsx:77
msgid "{account} published a post."
msgstr "Y·Tesuffeɣ-d {account} tasuffeɣt."

#: src/components/notification.jsx:85
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} yesnerna tiririt-ik·im.} other {{account} yesnerna tasuffeɣt-ik·im.}}} other {{account} yesnerna {postsCount} n tsuffaɣ-ik.}}} other {{postType, select, reply {<0><1>{0}</1> imdanen</0> snernan tiririt-ik·im.} other {<2><3>{1}</3> imdanen</2> zuzren tasuffeɣt-ik·im.}}}}"

#: src/components/notification.jsx:128
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {}=1 {{account} yeṭṭafar-ik.} other {<0><1>{0}</1> imdanen</0> ṭṭafaren-k.}}"

#: src/components/notification.jsx:142
msgid "{account} requested to follow you."
msgstr "{account} yessuter ad k-yeḍfer."

#: src/components/notification.jsx:151
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} teεǧeb-as tririt-ik·im.} other {{account} teεǧeb-as tsuffeɣt-ik·im.}}} other {{account} εeǧbent-as {postsCount} tsuffaɣ-ik·im.}}} other {{postType, select, reply {<0><1>{0}</1> imdanen</0> teεǧeb-asen·t tririt-ik·im.} other {<2><3>{1}</3> imdanen</2> teεǧeb-asen·t tsuffeɣt-ik·im.}}}}"

#: src/components/notification.jsx:193
msgid "A poll you have voted in or created has ended."
msgstr "Asisten i tferneḍ neɣ i terniḍ ifukk."

#: src/components/notification.jsx:194
msgid "A poll you have created has ended."
msgstr "Asisten i terniḍ ifukk."

#: src/components/notification.jsx:195
msgid "A poll you have voted in has ended."
msgstr "Ifukk usisten ideg tettekkaḍ."

#: src/components/notification.jsx:196
msgid "A post you interacted with has been edited."
msgstr "Tasuffeɣt iɣef twennteḍ tettwaẓreg."

#: src/components/notification.jsx:204
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} izuzer & teεǧeb-as tririt-ik·im.} other {{account} izuzer & teεǧeb-as tsuffeɣt-ik·im.}}} other {{account} izuzer & εeǧbent-as {postsCount} n tsuffaɣ-ik·im.}}} other {{postType, select, reply {<0><1>{0}</1> imdanen</0> zuzren & teεǧeb-asen·t tririt-ik·im.} other {<2><3>{1}</3> imdanen</2> zuzren & teεǧeb-asen·t tsuffeɣt-ik·im.}}}}"

#: src/components/notification.jsx:246
msgid "{account} signed up."
msgstr "{account} yeffeɣ."

#: src/components/notification.jsx:248
msgid "{account} reported {targetAccount}"
msgstr "{account} yettwasmater {targetAccount}"

#: src/components/notification.jsx:253
msgid "Lost connections with <0>{name}</0>."
msgstr "Ruḥent tuqqniwin akked <0>{name}</0>."

#: src/components/notification.jsx:259
msgid "Moderation warning"
msgstr "Alɣu n uqeεεed"

#: src/components/notification.jsx:269
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Anedbal seg <0>{from}</0> yettwaḥbes <1>{targetName}</1>, dayen ulac ileqman ara d-yawḍen sɣur-s neɣ amyigew yid-s."

#: src/components/notification.jsx:275
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Anedbal seg <0>{from}</0> yettusewḥel <1>{targetName}</1>. Ineḍfaren yettwaḥuzan: {followersCount}, ineḍfaren: {followingCount}."

#: src/components/notification.jsx:281
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Tesweḥleḍ <0>{targetName}</0>. Ineḍfaren yettwakksen: {followersCount}, ineḍfaren: {followingCount}."

#: src/components/notification.jsx:289
msgid "Your account has received a moderation warning."
msgstr "Amiḍan-ik yeṭṭef-d alɣu n uqeεεed."

#: src/components/notification.jsx:290
msgid "Your account has been disabled."
msgstr "Amiḍan-ik yensa."

#: src/components/notification.jsx:291
msgid "Some of your posts have been marked as sensitive."
msgstr "Kra seg tsuffaɣ-ik ttwacerḍent d timḥulfa."

#: src/components/notification.jsx:292
msgid "Some of your posts have been deleted."
msgstr "Kra seg tsuffaɣ-ik ttwakksent."

#: src/components/notification.jsx:293
msgid "Your posts will be marked as sensitive from now on."
msgstr "Tisuffaɣ-ik ad ttwacerḍent d tisuffaɣ timṣulfa sya d asawen."

#: src/components/notification.jsx:294
msgid "Your account has been limited."
msgstr "Amiḍan-ik yesεa tilas."

#: src/components/notification.jsx:295
msgid "Your account has been suspended."
msgstr "Yettwaseḥbes umiḍan-ik."

#: src/components/notification.jsx:369
msgid "[Unknown notification type: {type}]"
msgstr "[Anaw n wulɣu d arussin: {type}]"

#: src/components/notification.jsx:434
#: src/components/status.jsx:1020
#: src/components/status.jsx:1030
msgid "Boosted/Liked by…"
msgstr "Izuzer-it/Iḥemmel-it…"

#: src/components/notification.jsx:435
msgid "Liked by…"
msgstr "Iεǧeb-as i…"

#: src/components/notification.jsx:436
msgid "Boosted by…"
msgstr "Izuzer-it…"

#: src/components/notification.jsx:437
msgid "Followed by…"
msgstr "Iḍfer-it…"

#: src/components/notification.jsx:508
#: src/components/notification.jsx:524
msgid "Learn more <0/>"
msgstr "Issin ugar <0/>"

#: src/components/notification.jsx:756
#: src/components/status.jsx:251
msgid "Read more →"
msgstr "Γer ugar →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Yefren"

#: src/components/poll.jsx:116
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr ""

#: src/components/poll.jsx:136
#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Hide results"
msgstr "Ffer igmaḍ"

#: src/components/poll.jsx:185
msgid "Vote"
msgstr "Fren"

#: src/components/poll.jsx:205
#: src/components/poll.jsx:207
#: src/pages/status.jsx:1201
#: src/pages/status.jsx:1224
msgid "Refresh"
msgstr "Smiren"

#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Show results"
msgstr "Sken igmaḍ"

#: src/components/poll.jsx:228
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> afran} other {<1>{1}</1> ifranen}}"

#: src/components/poll.jsx:245
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> amefran} other {<1>{1}</1> imefranen}}"

#: src/components/poll.jsx:265
msgid "Ended <0/>"
msgstr "Ifukk <0/>"

#: src/components/poll.jsx:269
msgid "Ended"
msgstr "Ifukk"

#: src/components/poll.jsx:272
msgid "Ending <0/>"
msgstr "Yettfakk <0/>"

#: src/components/poll.jsx:276
msgid "Ending"
msgstr "Yettfakk"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0}tsn"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0}tsd"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0}srg"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "D aspam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Yir iseɣwan, yir agman d tririyin i d-yettuɣalen"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Arusḍif"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Ur iquder ara asaḍuf n tmurt-ik neɣ asaḍuf n uqeddac"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Takriṭ n ulugen n uqeddac"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Yerẓa ilugan uzzigen n uqeddac"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Takriṭ"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Ayen nniḍen"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Ugur ur yemmezg ara d taggayin niḍen"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Mmel tasuffeɣt"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Mmel @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Ittraǧu acegger"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Tasuffeɣt tattwammel"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Amaɣnu yettwammel"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "D awezɣi tummla n tsuffeɣt"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "D awezɣi tummla n umaɣnu"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "D acu i d ugur deg tsuffeɣt-a?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "D acu i d ugur deg umaɣnu-a?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Talɣut niḍen"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Welleh ɣer <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Azen aneqqis"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Yettwasgugem {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "D awezɣi asgugem n {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Azen aneqqis <0>+ Sgugem amaɣnu</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Yettusewḥel {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "D awezɣi asewḥel i {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Azen aneqqis <0>+ Sewḥel amaɣnu</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ imiḍanen, ihacṭagen & tisuffaɣ</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Tisuffaɣ yesɛan <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Tisuffaɣ yettwaweccmen <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Wali <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Imiḍanen yesɛan <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Agejdan / Aḍfar"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Azayez (Adigan / Asedduklan)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Amiḍan"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Ahacṭag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "Asulay n tebdart"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Adigan kan"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:193
msgid "Instance"
msgstr "Aqeddac"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Afrayan, am. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Nadi awal"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Afrayan, slid i uskar n waṭas n tgejda"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "e.g. PixelArt (ugar n 5, ferqen s tallunt)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Amidya kan"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:192
msgid "Shortcuts"
msgstr "Inegzumen"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Suzzeg tabdart n yinegzumen ara d-ibanen  am:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Tiqeffilt yettifliwen"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Iccer/Afeggag n wumuɣ"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Aṭas n tgejdiyin"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Ulac deg uskar n uskan amiran"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Nkez d asawen"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Nkez d akessar"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1298
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Ẓreg"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Rnu ugar n unegzum/tgejdit i wakken ad yekker."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Ulac tigejdit akka tura. Sit ɣef tqeffalt \"Rnu tigejdit\"."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Ulac inegzumen akka tura. Sit ɣef tqeffalt \"Rnu anegzum\"."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Ur tt-tefriḍ ara ɣef wacu ara ternuḍ?<0/>Ԑreḍ timerna<1>n ugejdan / Aḍfar akked ilɣa</1> d imezwura."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Ugar n tgejda {SHORTCUTS_LIMIT}"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Ugar n {SHORTCUTS_LIMIT} yinegzumen"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Kter/sifeḍ"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Rnu ajgu…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Rnu anegzum…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Tabdart tuzzigt d tafrayant. I uskar s waṭas n tgejda, tabdart tettwasra, ma ulac tigejdit ad teffer."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "I uskar s waṭas n tgejda, awal n unadi yettwasra, ma ulac tigejdit ad teffer."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Aṭas ihacṭagen ttwasefraken. Ferqen s tallunt."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Ẓreg anegzum"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Rnu anegzum"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Tasnimirt"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Tabdart"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Kter/Sifeḍ<0>Inegzumen</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Kter"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Senṭeḍ inegzumen da"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Asader inegzumen i yettwaskelsen seg uqeddac n tummant…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "D awezɣi asader n yinegzumen"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Sader inegzumen seg uqeddac n tummant"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Yella deg yinegzumen imiranen"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "Tabdart yezmer ur tetteddu ara ma yella tekka-d seg umiḍan niḍen."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Amasal n yiɣewwaren d arameɣtu"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Semselsi inegzumen imiranen?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Slid inegzumen i yulac deg yinegzumen imiranen ara yettwarnun."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Ulac inegzumen imaynuten i uktar"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Inegzumen ttwaktaren-d. Ԑeddan talast n {SHORTCUTS_LIMIT}, ɣef waya llan wid ur d-yettwaktaren ara."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Inegzumen ttwaketren"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Kter & semselsi…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Zgel inegzumen imiranen?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Kter inegzumen?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "neɣ zgel…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Kter…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Sifeḍ"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Inegzumen ttwaneɣlen"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "D awezɣi anɣal n yinegzumen"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Iɣewwaren n unegzum ttwaneɣlen"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "D awezɣi anɣal n yiɣewwaren n yinegzumen"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Bḍu"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Asekles n yinegzumen ɣef uqeddac n tummant…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Inegzumen ttwaskelsen"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "D awezɣi asekles n yinegzumen"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Mtawi akked uqeddac n tummant"

#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# asekkil} other {# isekkilen}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Inegzumen n yizirig JSON"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Kter/sifeḍ iɣewwaren seg/ɣer uqeddac n tummant (d armitan ugar)"

#: src/components/status.jsx:522
msgid "<0/> <1>boosted</1>"
msgstr "<0/><1>izuzer-it</1>"

#: src/components/status.jsx:621
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Nesḥassef, tummant-ik tamirantur yeqqnen ur tezmir ara ad temyigewt akked tsuffaɣt -a seg tummant tayeḍ."

#: src/components/status.jsx:774
msgid "Unliked @{0}'s post"
msgstr "Yekkes-as uεǧab i tsuffeɣt n @{0}"

#: src/components/status.jsx:775
msgid "Liked @{0}'s post"
msgstr "Teεǧeb-as tsuffeɣt n @{0}"

#: src/components/status.jsx:814
msgid "Unbookmarked @{0}'s post"
msgstr "Yekkes-as acraḍ i tsuffeɣt n @{0}"

#: src/components/status.jsx:815
msgid "Bookmarked @{0}'s post"
msgstr "Tettwacreḍ tsuffeɣt @{0}"

#: src/components/status.jsx:921
#: src/components/status.jsx:983
#: src/components/status.jsx:2396
#: src/components/status.jsx:2428
msgid "Unboost"
msgstr "Sefsex azuzer"

#: src/components/status.jsx:937
#: src/components/status.jsx:2411
msgid "Quote"
msgstr "Tanebdurt"

#: src/components/status.jsx:945
#: src/components/status.jsx:2420
msgid "Some media have no descriptions."
msgstr "Kra yimidyaten ulac ɣer-sen aglam."

#: src/components/status.jsx:952
msgid "Old post (<0>{0}</0>)"
msgstr "Tasuffeɣt taqburt (<0>{0}</0>)"

#: src/components/status.jsx:971
#: src/components/status.jsx:1426
msgid "Unboosted @{0}'s post"
msgstr "Tesfesxeḍ azuzer n tsuffeɣt n @{0}"

#: src/components/status.jsx:972
#: src/components/status.jsx:1427
msgid "Boosted @{0}'s post"
msgstr "Tezzuzreḍ tasuffeɣt n @{0}"

#: src/components/status.jsx:984
msgid "Boost…"
msgstr "Zuzer…"

#: src/components/status.jsx:996
#: src/components/status.jsx:1711
#: src/components/status.jsx:2441
msgid "Unlike"
msgstr "Kkes aεǧab"

#: src/components/status.jsx:997
#: src/components/status.jsx:1711
#: src/components/status.jsx:1712
#: src/components/status.jsx:2441
#: src/components/status.jsx:2442
msgid "Like"
msgstr "Ḥemmel"

#: src/components/status.jsx:1006
#: src/components/status.jsx:2453
msgid "Unbookmark"
msgstr "Kkes-as ticreḍt"

#: src/components/status.jsx:1114
msgid "View post by <0>@{0}</0>"
msgstr "Wali tasuffeɣt sɣur <0>@{0}</0>"

#: src/components/status.jsx:1135
msgid "Show Edit History"
msgstr "Sken azray n teẓrigin"

#: src/components/status.jsx:1138
msgid "Edited: {editedDateText}"
msgstr "Yettwaẓreg: {editedDateText}"

#: src/components/status.jsx:1205
#: src/components/status.jsx:3220
msgid "Embed post"
msgstr "Sidef tasuffeɣt"

#: src/components/status.jsx:1219
msgid "Conversation unmuted"
msgstr "Yettwafsi usgugem ɣef udiwenni"

#: src/components/status.jsx:1219
msgid "Conversation muted"
msgstr "Yettwasgugem udiwenni"

#: src/components/status.jsx:1225
msgid "Unable to unmute conversation"
msgstr "D awezɣi tukksa n usgugem i udiwenni"

#: src/components/status.jsx:1226
msgid "Unable to mute conversation"
msgstr "D awezɣi asgugem n udiwenni"

#: src/components/status.jsx:1235
msgid "Unmute conversation"
msgstr "Kkes asgugem n udiwenni"

#: src/components/status.jsx:1242
msgid "Mute conversation"
msgstr "Sgugem adiwenni"

#: src/components/status.jsx:1258
msgid "Post unpinned from profile"
msgstr "Tasuffeɣt tettwakkes seg umaɣnu"

#: src/components/status.jsx:1259
msgid "Post pinned to profile"
msgstr "Tasuffeɣt tettwasenteḍ ɣer umaɣnu"

#: src/components/status.jsx:1264
msgid "Unable to unpin post"
msgstr "D awezɣi aserreḥ n tsuffeɣt"

#: src/components/status.jsx:1264
msgid "Unable to pin post"
msgstr "D awezɣi asenteḍ n tsuffeɣt"

#: src/components/status.jsx:1273
msgid "Unpin from profile"
msgstr "Kkes asenteḍ seg umaɣnu"

#: src/components/status.jsx:1280
msgid "Pin to profile"
msgstr "Senteḍ ɣef umaɣnu"

#: src/components/status.jsx:1309
msgid "Delete this post?"
msgstr "Kkes tasuffeɣt-a?"

#: src/components/status.jsx:1325
msgid "Post deleted"
msgstr "Tasuffeɣt tettwakkes"

#: src/components/status.jsx:1328
msgid "Unable to delete post"
msgstr "D awezɣi tukksa n tsuffeɣt"

#: src/components/status.jsx:1356
msgid "Report post…"
msgstr "Mmel tasuffeɣt…"

#: src/components/status.jsx:1712
#: src/components/status.jsx:1748
#: src/components/status.jsx:2442
msgid "Liked"
msgstr "Iḥemmel"

#: src/components/status.jsx:1745
#: src/components/status.jsx:2429
msgid "Boosted"
msgstr "Tettwazuzer"

#: src/components/status.jsx:1755
#: src/components/status.jsx:2454
msgid "Bookmarked"
msgstr "Yettwacreḍ"

#: src/components/status.jsx:1759
msgid "Pinned"
msgstr "Yettwasenteḍ"

#: src/components/status.jsx:1804
#: src/components/status.jsx:2260
msgid "Deleted"
msgstr "Yettwakkes"

#: src/components/status.jsx:1845
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# tiririt} other {# tiririyin}}"

#: src/components/status.jsx:1934
msgid "Thread{0}"
msgstr "Asqerdec{0}"

#: src/components/status.jsx:2010
#: src/components/status.jsx:2072
#: src/components/status.jsx:2157
msgid "Show less"
msgstr "Ssken cwiṭ"

#: src/components/status.jsx:2010
#: src/components/status.jsx:2072
msgid "Show content"
msgstr "Sken agbur"

#: src/components/status.jsx:2157
msgid "Show media"
msgstr "Sken amidya"

#: src/components/status.jsx:2294
msgid "Edited"
msgstr "Yettwaẓrag"

#: src/components/status.jsx:2371
msgid "Comments"
msgstr "Iwenniten"

#. More from [Author]
#: src/components/status.jsx:2680
msgid "More from <0/>"
msgstr "Ugar sɣur <0/>"

#: src/components/status.jsx:2981
msgid "Edit History"
msgstr "Azray n teẓrigin"

#: src/components/status.jsx:2985
msgid "Failed to load history"
msgstr "Yecceḍ usali n uzray"

#: src/components/status.jsx:2990
msgid "Loading…"
msgstr "Yessalay-d…"

#: src/components/status.jsx:3225
msgid "HTML Code"
msgstr "Tangalt HTML"

#: src/components/status.jsx:3242
msgid "HTML code copied"
msgstr "Tangalt HTML tettwanɣal"

#: src/components/status.jsx:3245
msgid "Unable to copy HTML code"
msgstr "D awezɣi anɣal n tengalt HTML"

#: src/components/status.jsx:3257
msgid "Media attachments:"
msgstr "Imeddayen n umidya:"

#: src/components/status.jsx:3279
msgid "Account Emojis:"
msgstr "Imujiṭen n umiḍan:"

#: src/components/status.jsx:3310
#: src/components/status.jsx:3355
msgid "static URL"
msgstr "URL n tdaddanin"

#: src/components/status.jsx:3324
msgid "Emojis:"
msgstr "Imujiten:"

#: src/components/status.jsx:3369
msgid "Notes:"
msgstr "Tizmilin:"

#: src/components/status.jsx:3373
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Tidaddanin-a war talɣa, war tira. Ahat yessefk ad tesnaseḍ talɣiwin-ik, ad ten-tbeddleḍ melmi i tebɣiḍ."

#: src/components/status.jsx:3379
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Isestanen ur myigawen ara, ttuɣalen d tabdart s umḍan n ufran."

#: src/components/status.jsx:3384
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Imeddayen n umidya zemren ad ilin d tugniwin, d tividyutin, d iseklasen imeslawen neɣ kra n wawan n ufaylu."

#: src/components/status.jsx:3390
msgid "Post could be edited or deleted later."
msgstr "Tasuffeɣt tezmer ad tettwaẓrag neɣ ad tettwakkes ticki."

#: src/components/status.jsx:3396
msgid "Preview"
msgstr "Askan"

#: src/components/status.jsx:3405
msgid "Note: This preview is lightly styled."
msgstr "Tamawt: Taskant-a tettufeṣṣel s wudem afessas."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3647
msgid "<0/> <1/> boosted"
msgstr "Izuzer-itt <0/><1/>"

#: src/components/timeline.jsx:453
#: src/pages/settings.jsx:1130
msgid "New posts"
msgstr "Tisuffaɣ timaynutin"

#: src/components/timeline.jsx:554
#: src/pages/home.jsx:213
#: src/pages/notifications.jsx:824
#: src/pages/status.jsx:988
#: src/pages/status.jsx:1361
msgid "Try again"
msgstr "Ɛreḍ tikkelt-nniḍen"

#: src/components/timeline.jsx:588
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# n uzuzer} other {# n yizurar}}"

#: src/components/timeline.jsx:593
msgid "Pinned posts"
msgstr "Tisuffaɣ yettwasenṭḍen"

#: src/components/timeline.jsx:946
#: src/components/timeline.jsx:953
#: src/pages/catchup.jsx:1893
msgid "Thread"
msgstr "Asqerdec"

#: src/components/timeline.jsx:968
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Yettwasizdeg</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Tasuqilt tawurmant seg {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Yessuqul…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Suqel seg {sourceLangText} (tifin tawurmant)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Ssuqel seg {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Awurman ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Tuccḍa deg tsuqilt"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Aẓrag n waddad n uɣbalu"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Tiririt i @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Tzemreḍ ad tmedleḍ asebtar tura."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Mdel asfaylu"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Tuqqna tettwasra."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:270
msgid "Go home"
msgstr "Uɣal ɣer ugejdan"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Tisuffaɣ n umiḍan"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ tririyin)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Izuzar)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Amidya)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Sfeḍ imsizedgen"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Sfeḍ"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Askan n tsuffeɣt s tririyin"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "ugar n tririyin"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Sken tisuffaɣ war azuzer"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Izuzar"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Askan n tisuffaɣ s umidya"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Askan n tsuffaɣ yettwabdaren s #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Askan n tsuffaɣ deg {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Ulac acu ara twaliḍ dagi akka ar tura."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:449
msgid "Unable to load posts"
msgstr "D awezɣi alluy n tsuffaɣ"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "D awezɣi tiririt n telɣut n umiḍan"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Uɣal ɣer tummant n umiḍan {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Uɣal ɣer tummant-iw (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Ayyur"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Melmi kan"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Amezwer"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Uɣal ɣer umiḍan-a"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Uɣal ɣer yiccer/usfaylu amaynut"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Wali amaɣnu…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Sbadu-t d amezwer"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Ffeɣ <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Ffeɣ…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Rnu amiḍan yellan yakan"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Tamawt: Amiḍan <0>amezwer</0> ad yezg yettwaseqdac deg usali amezwaru. Imiḍanen yettwasneflen ad qqimen ɣef teɣzi n tɣimit."

#: src/pages/bookmarks.jsx:25
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Werɛad ur tesɛiḍ ara ticraḍ. Ddu ad d-tcerḍeḍ kra!"

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "D awezɣi ad d-alint tecraḍ n yisebtar."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "1 usrag aneggaru"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "2 yisragen ineggura"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "3 yisragen ineggura"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "4 yisragen ineggura"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "5 yisragen ineggura"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "6 yisragen ineggura"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "7 yisragen ineggura"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "8 yisragen ineggura"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "9 yisragen ineggura"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "10 yisragen ineggura"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "11 yisragen ineggura"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "12 yisragen ineggura"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "ugar n 12 yisragen"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Tibzimin yettwaḍefren"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Igrawen"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Askan n {selectedFilterCategory, select, all {akk tisuffaɣ} original {tisuffaɣ tiɣbula} replies {tiririyin} boosts {izuzar} followedTags {tibzimin yettwaḍefren} groups {igrawzen} filtered {tisuffaɣ yettwaszedgen}}, {sortBy, select, createdAt {{sortOrder, select, asc {tiqburin akk} desc {tingurra akk}}} reblogsCount {{sortOrder, select, asc {drus n yizuzar} desc {aṭas n yizuzar}}} favouritesCount {{sortOrder, select, asc {drus n yismenyaf} desc {aṭas n yismenyaf}}} repliesCount {{sortOrder, select, asc {drus n tririyin} desc {aṭas n tririyin}}} density {{sortOrder, select, asc {adday n tneẓẓit} desc {afellay n tneẓẓit}}}} amezwaru{groupBy, select, account {, ttusgarwen almend n yimeskar} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Alukem <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Tallelt"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "D acu-t wa?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Alukem d tasnimirt niḍen ii yineḍfaren-ik, i d-yettmuddun udem s uswir εlayen deg uṛmac n tiṭ, s ugrudem afessas igan am wudem n yimayl i ufran n tsuffaɣ d usizdeg-nsent."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Taskant n ugrudem n ulukem"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Yebda"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Lukem tisuffaɣ n yineḍfaren-ik."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Sken-iyi-d akk tisuffaɣ sɣur…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "alamma dayen"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Alukem"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Yemyikcam akked ulukem-ik aneggaru"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Alamma d alukem aneggaru ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Tamawt: tummant-ik tezmer kan ad tesken ugar n 800 tsuffaɣ deg tesnimirt n ugejdan akken yebɣu yili uzrar n wakud. Aya yezmer ad yili ugar neɣ drus."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Uqbel…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# tasuffeɣt} other {# tisuffaɣ}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Kkes alukem-a?"

#: src/pages/catchup.jsx:1065
msgid "Removing Catch-up {0}"
msgstr ""

#: src/pages/catchup.jsx:1069
msgid "Catch-up {0} removed"
msgstr ""

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Tamawt: Ugar kan n 3 ad d-ttwarrent. Ayen d-yeqqimen ad ttwakksent s wudem awurman."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Asali n tsuffaɣ…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Aya yezmer ad yeṭṭef kra n wakud."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Wennez imsizedgen"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "Iseɣwan ufrinen"

#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Yebḍa-tt {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:297
msgid "All"
msgstr "Akk"

#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# ameskar} other {# imeskaren}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Semyizwer"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Azemz"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Taneẓẓi"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1471
msgid "group.filter"
msgstr ""

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Imeskaren"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Ula yiwen"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Wali akk imeskaren"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Fiḥel ad teɣreḍ kullec."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "D ayen kan."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Uɣal ar tqacuct"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Iseɣwan yettwabḍan sɣur yineḍfaren, myezwaren almend n umḍan n beṭṭu, izuzar d yismenyifen."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Semyizwer: Taneẓẓi"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Tisuffaɣ myezwarent almend n tneẓẓit n telɣut neɣ s telqayt. Tisuffaɣ timeẓẓyanin \"fessusit\" ma yella d tisuffaɣ tiɣezzfanin \"ẓẓayit\". Tisuffaɣ s tewlafin \"ẓẓayit\" ɣef tsuffaɣ war tiwlafin."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Agraw: Imeskaren"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Tisuffaɣ ttusgarwent almend n yimeskar, myizwarent almend n umḍan n tsuffaɣ i umeskar."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Ameskar uḍfir"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Ameskar udfir"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Ali d asawen"

#: src/pages/catchup.jsx:1875
msgid "Filtered: {0}"
msgstr "Yettwasizdeg: {0}"

#: src/pages/favourites.jsx:25
msgid "No likes yet. Go like something!"
msgstr ""

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "D awezɣi asali n yismenyafen."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Agejdan akked tebdarin"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Tisnimirin tizayazin"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Idiwenniyen"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Imuɣna"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Werǧin"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Amsizdeg amaynut"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# imsizdeg} other {# imsizedgen}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "D awezɣi ad d-alin imsizedgen."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Ulac imsizdeg akka tura."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Rnu imsizdeg"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Ẓreg amsizdeg"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "D awezɣi asiẓreg n yimsizdeg"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "D awezɣi timerna n yimsizdeg"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Azwel"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Awal ummid"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Ulaw awalen n tsura. Rnu yiwen."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Rnu awal tasarut"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# awal n tsarut} other {# awalen n tsura}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Sizdeg seg…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Mazal ur yebdid ara ar tura"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Addad: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Senfel taggara"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Keffu"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Tisuffaɣ yettwasezdgen ad…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "yettwasemẓẓin"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "yettwaffer"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Kkes imsizdeg-a?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "D awezɣi tukksa n yimsizdeg."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Ad yekfu"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Ad yekfu <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Ur ikeffu ara"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# ahacṭag} other {# ihacṭagen}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "D awezɣi asali n yihacṭagen i yettwaḍfaren."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Ulac ihacṭagen i yettwaḍfaren akka ar tura."

#: src/pages/following.jsx:143
msgid "Nothing to see here."
msgstr "Ulac acu ara twaliḍ dagi."

#: src/pages/following.jsx:144
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "D awezɣi alluy n tsuffaɣ."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Amidya kan) ɣef {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} ɣef {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (Amidya kan)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Ulac win i d-isuffɣen kra s tebzimt-a akka ar tura."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "D awezɣi asali n tsuffaɣ s tebzimt-a"

#: src/pages/hashtag.jsx:208
msgid "Unfollow #{hashtag}?"
msgstr "Ur ṭṭafar ara #{hashtag}?"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "Ur yettwaḍfar ara #{hashtag}"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Yettwaḍfar #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Yeṭṭafar…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Yettwakkes seg umaɣnu"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "D awezɣi tukksa seg umaɣnu"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Yella ɣef umaɣnu-k"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Welleh fell-as deg umaɣnu-k"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Ugar # tibzimin}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Rnu ahacṭag"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Kkes ahacṭag"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Amḍan afellay n # unegzum yewweḍ. D awezɣi timerna n unegzum.} other {Amḍan afellay # yinegzumen yewweḍ. D awezɣi timerna n unegzum.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Anegzum-a yella yakan"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Anegzum n uhacṭag yettwarna"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Rnu ɣer inezgumen"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:478
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Sekcem-d aqedac amaynut, amedya \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:481
msgid "Invalid instance"
msgstr "Yir tummant"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:493
msgid "Go to another instance…"
msgstr "Ddu ɣer uqeddac-nniḍen…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:504
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Ddu ɣer tummant-iw (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:209
msgid "Unable to fetch notifications."
msgstr "D awazeɣi asali n yilɣa."

#: src/pages/home.jsx:229
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Amaynut</0> <1>Ḍfer issutar</1>"

#: src/pages/home.jsx:235
msgid "See all"
msgstr "Wali-ten akk"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Iferru…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "D awezɣi ferru n URL"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Ulac i yellan akka tura."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Sefrek imttekkiyen"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Kkes <0>@{0}</0> seg tebdart?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Kkes…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# tabdart} other {# tibdarin}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Ulac tibdarinakka tura."

#: src/pages/login.jsx:109
#: src/pages/login.jsx:122
msgid "Failed to register application"
msgstr "Ur yessaweḍ ara ad ijerred asnas-nni"

#: src/pages/login.jsx:208
msgid "instance domain"
msgstr ""

#: src/pages/login.jsx:232
msgid "e.g. “mastodon.social”"
msgstr "amedya \"mastodon.social\""

#: src/pages/login.jsx:243
msgid "Failed to log in. Please try again or try another instance."
msgstr "Ur yessaweḍ ara ad yekcem. Ttxil-k·m, ɛreḍ tikkelt nniḍen neɣ ɛreḍ aqeddac nniḍen."

#: src/pages/login.jsx:255
msgid "Continue with {selectedInstanceText}"
msgstr "Kemmel s {selectedInstanceText}"

#: src/pages/login.jsx:256
msgid "Continue"
msgstr "Kemmel"

#: src/pages/login.jsx:264
msgid "Don't have an account? Create one!"
msgstr "Ur tesεiḍ ara amiḍan? Snulfu-d yiwen!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Tabdarin tusligin"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Usligen"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Ulac win k-id-ibedren :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "D awezɣi ad d-alin ibdaren."

#: src/pages/notifications.jsx:103
msgid "You don't follow"
msgstr "Ur teṭtafareḍ ara"

#: src/pages/notifications.jsx:104
msgid "Who don't follow you"
msgstr "Anwa ur k-neṭṭafar ara"

#: src/pages/notifications.jsx:105
msgid "With a new account"
msgstr "S umiḍan amaynut"

#: src/pages/notifications.jsx:106
msgid "Who unsolicitedly private mention you"
msgstr "D anwa i k-id-ibedren s wudem uslig war ma yessuter-ak-d"

#: src/pages/notifications.jsx:107
msgid "Who are limited by server moderators"
msgstr "D anwi iwumi gan imḍebbren n uqeddac tilas"

#: src/pages/notifications.jsx:538
#: src/pages/notifications.jsx:872
msgid "Notifications settings"
msgstr "Iɣewwaṛen n wulɣu"

#: src/pages/notifications.jsx:556
msgid "New notifications"
msgstr "Ulɣuten imaynuten"

#: src/pages/notifications.jsx:567
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Alɣu} other {Alɣuten}}"

#: src/pages/notifications.jsx:614
#: src/pages/settings.jsx:1118
msgid "Follow requests"
msgstr "Issutar n uḍfar"

#: src/pages/notifications.jsx:619
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# ḍfer assuter} other {# ḍfer issutar}}"

#: src/pages/notifications.jsx:674
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Ttwasezdgen yilɣa sɣur # amdan} other {Ttwasezdgen yilɣa sɣur # imdanen}}"

#: src/pages/notifications.jsx:740
msgid "Only mentions"
msgstr "Ibdaren kan"

#: src/pages/notifications.jsx:744
msgid "Today"
msgstr "Ass-a"

#: src/pages/notifications.jsx:749
msgid "You're all caught up."
msgstr "Tessawḍeḍ kullec."

#: src/pages/notifications.jsx:772
msgid "Yesterday"
msgstr "Iḍelli"

#: src/pages/notifications.jsx:820
msgid "Unable to load notifications"
msgstr "D awezɣi ad d-alin ilɣa"

#: src/pages/notifications.jsx:899
msgid "Notifications settings updated"
msgstr "Iɣewwaṛen n wulɣu ttwaleqqmen"

#: src/pages/notifications.jsx:907
msgid "Filter out notifications from people:"
msgstr "Sizdeg ilɣa n yimdanen:"

#: src/pages/notifications.jsx:921
msgid "Filter"
msgstr "Imsizdeg"

#: src/pages/notifications.jsx:924
msgid "Ignore"
msgstr "Anef"

#: src/pages/notifications.jsx:997
msgid "Updated <0>{0}</0>"
msgstr "Yettwaleqqem <0>{0}</0>"

#: src/pages/notifications.jsx:1065
msgid "View notifications from <0>@{0}</0>"
msgstr "Wali ilɣa seg <0>@{0}</0>"

#: src/pages/notifications.jsx:1086
msgid "Notifications from <0>@{0}</0>"
msgstr "Ilɣa sɣur <0>@{0}</0>"

#: src/pages/notifications.jsx:1153
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Ilɣa sɣur @{0} ad uɣalen ad ffren sya ar sdat."

#: src/pages/notifications.jsx:1158
msgid "Unable to accept notification request"
msgstr "D awezεi aqbal n ussuter n wulɣu"

#: src/pages/notifications.jsx:1163
msgid "Allow"
msgstr "Sireg"

#: src/pages/notifications.jsx:1183
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Ilɣa sɣur @{0} ur d-ttwaskanen ara deg yilɣa yettwaszedgen sya d afella."

#: src/pages/notifications.jsx:1188
msgid "Unable to dismiss notification request"
msgstr "D awezεi tigtin n ussuter n wulɣu"

#: src/pages/notifications.jsx:1193
msgid "Dismiss"
msgstr "Zgel"

#: src/pages/notifications.jsx:1208
msgid "Dismissed"
msgstr "Yettwazgel"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Tasuddemt tadigant ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Tasuddemt tasedduklant ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Tasuddemt tadigant"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Tasnimirt tazayazt tamatut"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Ulac win i d-isuffɣen kra akka ar tura."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Bren ɣer tesdduklant"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Uɣal ɣer udigan"

#: src/pages/search.jsx:49
msgid "Search: {q} (Posts)"
msgstr "Nadi: {q} (Tisuffaɣ)"

#: src/pages/search.jsx:52
msgid "Search: {q} (Accounts)"
msgstr "Nadi: {q} (Imiḍanen)"

#: src/pages/search.jsx:55
msgid "Search: {q} (Hashtags)"
msgstr "Nadi: {q} (Ihacṭagen)"

#: src/pages/search.jsx:58
msgid "Search: {q}"
msgstr "Nadi: {q}"

#: src/pages/search.jsx:307
#: src/pages/search.jsx:389
msgid "Hashtags"
msgstr "Ihacṭagen"

#: src/pages/search.jsx:339
#: src/pages/search.jsx:393
#: src/pages/search.jsx:463
msgid "See more"
msgstr "Wali ugar"

#: src/pages/search.jsx:365
msgid "See more accounts"
msgstr "Wali ugar n imiḍanen"

#: src/pages/search.jsx:379
msgid "No accounts found."
msgstr "Ulac imiḍanen yettwafen."

#: src/pages/search.jsx:435
msgid "See more hashtags"
msgstr "Wali ugar n ihacṭagen"

#: src/pages/search.jsx:449
msgid "No hashtags found."
msgstr "Ulac ihacṭagen i yettwafen."

#: src/pages/search.jsx:493
msgid "See more posts"
msgstr "Wali ugar n tsuffaɣ"

#: src/pages/search.jsx:507
msgid "No posts found."
msgstr "Ulac tisuffaɣ i yettwafen."

#: src/pages/search.jsx:551
msgid "Enter your search term or paste a URL above to get started."
msgstr "Sekcem awal-ik·im n unadi neɣ senteḍ URL nnig i wakken ad tebduḍ."

#: src/pages/settings.jsx:81
msgid "Settings"
msgstr "Iɣewwaṛen"

#: src/pages/settings.jsx:90
msgid "Appearance"
msgstr "Udem"

#: src/pages/settings.jsx:166
msgid "Light"
msgstr "Aceɛlal"

#: src/pages/settings.jsx:177
msgid "Dark"
msgstr "Ubrik"

#: src/pages/settings.jsx:190
msgid "Auto"
msgstr "Awurman"

#: src/pages/settings.jsx:200
msgid "Text size"
msgstr "Teɣzi n uḍris"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:205
#: src/pages/settings.jsx:230
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:244
msgid "Display language"
msgstr "Tutlayt n uskan"

#: src/pages/settings.jsx:253
msgid "Volunteer translations"
msgstr "Iwaziwen n tsuqilin"

#: src/pages/settings.jsx:264
msgid "Posting"
msgstr "Asuffeɣ"

#: src/pages/settings.jsx:271
msgid "Default visibility"
msgstr "Abani amezwer"

#: src/pages/settings.jsx:272
#: src/pages/settings.jsx:318
msgid "Synced"
msgstr "Yemtawa"

#: src/pages/settings.jsx:297
msgid "Failed to update posting privacy"
msgstr "Ur yessaweḍ ara ad ileqqem tabaḍnit n usuffeɣ"

#: src/pages/settings.jsx:320
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Yemtawa akked yiɣewwaren n uqeddac n tummant-ik. <0>Ddu ɣer tummant-ik ({instance}) i wugar n yiɣewwaren.</0>"

#: src/pages/settings.jsx:335
msgid "Experiments"
msgstr "Tirmatin"

#: src/pages/settings.jsx:348
msgid "Auto refresh timeline posts"
msgstr "Asmiren awurman n tsuffaɣ n tesnimirt"

#: src/pages/settings.jsx:360
msgid "Boosts carousel"
msgstr "Kaṛusel n yizuzar"

#: src/pages/settings.jsx:376
msgid "Post translation"
msgstr "Asuqqel n tsuffeɣt"

#: src/pages/settings.jsx:387
msgid "Translate to"
msgstr "Suqel ɣer"

#: src/pages/settings.jsx:398
msgid "System language ({systemTargetLanguageText})"
msgstr "Tutlayt n unagraw ({systemTargetLanguageText})"

#: src/pages/settings.jsx:424
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, one {}=0 {Ffer taqeffalt \"Suqqel\" i:} other {Ffer taqeffalt \"Suqqel\" i (#):}}"

#: src/pages/settings.jsx:478
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Tamawt: Tamahilt-a tesseqdac imeẓla n usuqqel azɣaray, tella s lmendad n <0>Lingva API</0> & <1>Lingva Translate</1>."

#: src/pages/settings.jsx:512
msgid "Auto inline translation"
msgstr "Tasuqilt tawurmant srid"

#: src/pages/settings.jsx:516
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Sken tisuqilin s wudem awurman i tsuffaɣ deg tesnimirt. Tetteddu kan i tsuffaɣ <0>timeẓẓyanin</0> war alɣu n ugbur, amidya akked usisten."

#: src/pages/settings.jsx:536
msgid "GIF Picker for composer"
msgstr "Amefran n GIF i umsuddes"

#: src/pages/settings.jsx:540
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Tamawt: Tamahilt-a tesseqdac ameẓlu n unadi n GIF azɣaray, s ttawil n <0>GIPHY</0>. Asesmel G (yemmezg akked meṛṛa iwtayen), iɣewwaren n uḍfar ttwakksen, talɣut n temselɣut tettwasfeḍ seg yissutar, maca issutar n unadi d telɣut n tansa IP ad wwḍen yal tikkelt ɣer yiqeddacen-nsen."

#: src/pages/settings.jsx:569
msgid "Image description generator"
msgstr "Asaraw n uglam n tugna"

#: src/pages/settings.jsx:574
msgid "Only for new images while composing new posts."
msgstr "I tugniwin timaynutin kan mi ara taruḍ tisuffaɣ timaynutin."

#: src/pages/settings.jsx:581
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Tamawt: Tamahilt-a tesseqdac ameẓlu AI azɣaray, s ttawil n <0>img-alt-api</0>. YEzmer ur iteddu ara. Slid i tugniwin yerna s Teglizit."

#: src/pages/settings.jsx:607
msgid "Server-side grouped notifications"
msgstr "Ilɣa ttusgarwen deg yidis n uqeddac"

#: src/pages/settings.jsx:611
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Tamahilt deg takkayt n Alfa. Asfaylu n usegrew abruyan tettwasnerna d acu tameẓla n usegrew tazadurt."

#: src/pages/settings.jsx:632
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Aktar/asifeḍ n \"Asigna\" i yiɣewwaren n yinegzumen"

#: src/pages/settings.jsx:637
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ D armitan ugar.<0/>Yettwasekles deg tezmilin n umaɣnu-k. Tizmilin-a n umaɣnu (tusligin) ttuseqdacent s umata ɣef yimuɣna niḍen, ffrent ɣef umaɣnu-k."

#: src/pages/settings.jsx:648
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Tamawt: Tamahilt-a tesseqdac API n uqeddac n usesteb yellan akka tura."

#: src/pages/settings.jsx:665
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Askar uffir <0>(<1>Aḍris</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:674
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Semselsi aḍris s yiḥedren, lhan i tuṭṭfiwin n ugdil, i tiɣẓinin n tbaḍnit."

#: src/pages/settings.jsx:699
msgid "About"
msgstr "Ɣef"

#: src/pages/settings.jsx:738
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Built</0> sɣur <1>@cheeaun</1>"

#: src/pages/settings.jsx:767
msgid "Sponsor"
msgstr "S lmendad"

#: src/pages/settings.jsx:775
msgid "Donate"
msgstr "Mudd tawsa"

#: src/pages/settings.jsx:783
msgid "Privacy Policy"
msgstr "Tasertit tabaḍnit"

#: src/pages/settings.jsx:790
msgid "<0>Site:</0> {0}"
msgstr "<0>Asmel:</0> {0}"

#: src/pages/settings.jsx:797
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Lqem:</0> <1/> {0}"

#: src/pages/settings.jsx:812
msgid "Version string copied"
msgstr "Azrir n lqem yettwanɣel"

#: src/pages/settings.jsx:815
msgid "Unable to copy version string"
msgstr "D awezɣi anɣal n uzrir n lqem"

#: src/pages/settings.jsx:1015
#: src/pages/settings.jsx:1020
msgid "Failed to update subscription. Please try again."
msgstr "Yecceḍ uleqqem n uglam. Ttxil-k, εreḍ tikkelt niḍen."

#: src/pages/settings.jsx:1026
msgid "Failed to remove subscription. Please try again."
msgstr "Yecceḍ tukksa n uglam. Ttxil-k, εreḍ tikkelt niḍen."

#: src/pages/settings.jsx:1033
msgid "Push Notifications (beta)"
msgstr "Ilɣa Push (beta)"

#: src/pages/settings.jsx:1055
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Ilɣa Push ttusweḥlen. Ttxil-k rmed-iten deg yiɣewwaren n yiminig."

#: src/pages/settings.jsx:1064
msgid "Allow from <0>{0}</0>"
msgstr "Sireg seg <0>{0}</0>"

#: src/pages/settings.jsx:1073
msgid "anyone"
msgstr "yal yiwen"

#: src/pages/settings.jsx:1077
msgid "people I follow"
msgstr "imdanen I aneḍfar"

#: src/pages/settings.jsx:1081
msgid "followers"
msgstr "imeḍfaṛen"

#: src/pages/settings.jsx:1114
msgid "Follows"
msgstr "T·Yeṭafaṛ"

#: src/pages/settings.jsx:1122
msgid "Polls"
msgstr "Isestanen"

#: src/pages/settings.jsx:1126
msgid "Post edits"
msgstr "Ibeddilen n tsuffeɣt"

#: src/pages/settings.jsx:1147
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Tisirag Push ur ttwamuddent ara seg unekcum aneggaru. Tesriḍ <0><1>ad teqqneḍ</1> tikkelt niḍen i wakken ad tmuddeḍ tisirag push</0>."

#: src/pages/settings.jsx:1163
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "Tamawt: Ilɣa Push teddun kan i <0>yiwen n umiḍan</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:597
#: src/pages/status.jsx:1131
msgid "post.title"
msgstr ""

#: src/pages/status.jsx:822
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Ur teqqineḍ ara. Amiyigew (tiririt, azuzer, rtg) ur teddun ara."

#: src/pages/status.jsx:842
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Tasuffeɣt-a seg tummant niḍen (<0>{instance}</0>). Amyigew (tiririt, azuzer, rtg) ur ddint ara."

#: src/pages/status.jsx:870
msgid "Error: {e}"
msgstr "Tuccḍa: {e}"

#: src/pages/status.jsx:877
msgid "Switch to my instance to enable interactions"
msgstr "Uɣal ɣer tummant-iw i urmad n umyigew"

#: src/pages/status.jsx:979
msgid "Unable to load replies."
msgstr "D awezɣi ad d-alint tririyin."

#: src/pages/status.jsx:1091
msgid "Back"
msgstr "Tuɣalin"

#: src/pages/status.jsx:1122
msgid "Go to main post"
msgstr "Ddu ɣer tsuffeɣt tagejdant"

#: src/pages/status.jsx:1145
msgid "{0} posts above ‒ Go to top"
msgstr "{0} n tsuffaɣ nnig - Ali d asawen"

#: src/pages/status.jsx:1188
#: src/pages/status.jsx:1251
msgid "Switch to Side Peek view"
msgstr "Ddu ɣer yidis n uskan Peek"

#: src/pages/status.jsx:1252
msgid "Switch to Full view"
msgstr "Uɣal s uskan ummid"

#: src/pages/status.jsx:1270
msgid "Show all sensitive content"
msgstr "Sken akk agbur amḥulfu"

#: src/pages/status.jsx:1275
msgid "Experimental"
msgstr "Armitan"

#: src/pages/status.jsx:1284
msgid "Unable to switch"
msgstr "D awezɣi abeddel"

#: src/pages/status.jsx:1291
msgid "Switch to post's instance ({0})"
msgstr "Uɣal ɣer tummant n tsuffeɣt ({0})"

#: src/pages/status.jsx:1294
msgid "Switch to post's instance"
msgstr "Uɣal ɣer tummant n tsuffeɣt"

#: src/pages/status.jsx:1352
msgid "Unable to load post"
msgstr "D awezɣi alluy n tsuffeɣt"

#: src/pages/status.jsx:1487
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# tiririt} other {<0>{1}</0> tiririyin}}"

#: src/pages/status.jsx:1505
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# awennit} other {<0>{0}</0> iwenniten}}"

#: src/pages/status.jsx:1527
msgid "View post with its replies"
msgstr "Wali tasuffeɣt s tririyin-is"

#: src/pages/trending.jsx:71
msgid "Trending ({instance})"
msgstr "Amuceε ({instance})"

#: src/pages/trending.jsx:228
msgid "Trending News"
msgstr "Isalan mucaɛen"

#. By [Author]
#: src/pages/trending.jsx:347
msgid "By {0}"
msgstr "Sɣur {0}"

#: src/pages/trending.jsx:408
msgid "Back to showing trending posts"
msgstr "Uɣal ɣer uskan n tsuffaɣ mucaεen"

#: src/pages/trending.jsx:413
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Askan n tsuffaɣ i d-ibedren <0>{0}</0>"

#: src/pages/trending.jsx:425
msgid "Trending posts"
msgstr "Tisuffaɣ mucaɛen"

#: src/pages/trending.jsx:448
msgid "No trending posts."
msgstr "Ulac tisuffaɣ mucaɛen."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Amsaɣ n Mastodon yella yettwali-t s tmuɣli taḥeqqart."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Qqen s Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Jerred"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Qqen amiḍan-ik Mastodon/Fedivers i yellan.<0/>Inekcam-ik ur ttwaskelsen ara ɣef uqeddac-a."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Yettwabna</0> sɣur <1>@cheeaun</1>. <2>Tasertit n tbaḍnit</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Tuṭṭfa n ugdil n kaṛusel n yizuzar"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Kaṛusel n yizuzar"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Freq s tmuɣli tisuffaɣ tiɣbula akked tsufaɣ yettwalsen beṭṭu (tisuffaɣ yettwazuzren)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Tuṭṭfa n ugdil n yiwenniten yimyikcamen"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Azrar n yiwenniten yemyikcamen"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Ḍfer idiwenniyen war ussis. Tiririt s uzgen-afnaẓ."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Tuṭṭfa n ugdil n yilɣa yettusgerwen"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Ilɣa ttusgarwen"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Ilɣa uluten ttusgarwen syen ttufenẓen i usenqes seg temterwit."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Tuṭṭfa n ugdil n ugrudem n waṭas n tgejda"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Yiwet neɣ aṭas n tgejdiyin"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "S wudem amezwer, tigejdit tasuft i i umnadi n uskar Zen. Aṭas n tgejda ttwasestabent i yiseqdacen n tsaraɣt."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Tuṭṭfa n ugdil n tesnimirt n yihacṭagen s tferkit i tmerna n wugar ihacṭagen"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Tasnimirt n waṭas yihacṭagen"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Ugar n 5 yihacṭagen ttwasdukklen deg yiwet n tesnimirt."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Yettban-d iminig-ik yessewḥal isfuyla udhimen."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Tasuffaɣt tarewwayt tettwasemẓẓi akka tura. Suffeɣ neɣ sefsex-itt send timerna n yiwet n tmaynut."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Tasuffaɣt teldi akka tura. Suffeɣ neɣ sefsex-itt send timerna n yiwet n tmaynut."

